import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Typography, Loader, Select } from "components";
import { useWindowDimensions } from "hooks";
import { getUniqueTransactionTypes, formatAmount } from "utils/helper";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import transactionVolumeImg from "assets/images/volume-chart-img.svg";
import { getTransactionTypeStats } from "redux/actions/dashboard/terminalDashboardActions";

const TransactionTypeStats = () => {
  const { width } = useWindowDimensions();
  const [transactionType, setTransactionType] = useState("1");

  const isSmallScreen = width < 992;

  const { transactionTypeStats } = useSelector(
    (state) => state.terminalDashboardReducer
  );

  const { transactionTypes } = useSelector(
    (state) => state.transactionsReducer
  );

  const { data, loading } = transactionTypeStats;

  const { totalTransVolume, totalTransValue, details } = data || {};

  useEffect(() => {
    getTransactionTypeStats();

    //eslint-disable-next-line
  }, []);

  const uniqueTransactionTypes = getUniqueTransactionTypes(transactionTypes);

  const colorCodes = [
    "#8280FF",
    "#102E88",
    "#3784FB",
    "#27AE60",
    "#5270CC",
    "#E4EAFD",
  ];

  const getColorIndicators = () =>
    data.details?.map((entry, index) => (
      <div className="mt-2 d-flex align-items-center" key={index}>
        <div
          className="transaction-indicator"
          style={{ backgroundColor: colorCodes[index] }}
        ></div>
        <div>
          <Typography variant="caption0" style={{ lineHeight: "17px" }}>
            {
              uniqueTransactionTypes?.find((transType) => {
                return (
                  transType.type.toLowerCase() === entry.transType.toLowerCase()
                );
              })?.description
            }
          </Typography>
          <Typography variant="caption2">
            {transactionType === "1" ? entry.volumePerc : entry.valuePerc}%
          </Typography>
        </div>
      </div>
    ));

  return (
    <div className="dashboard-card transaction-type-container pb-2">
      <div className="row pt-2 px-4">
        <div className="col-7 text-center">
          <Typography
            className="text-center mt-1 "
            state="primary"
            variant="body2"
          >
            Transaction Type Statistics
          </Typography>
          {loading ? (
            <div
              className={"text-center"}
              style={{ marginTop: "6rem", height: "13rem" }}
            >
              <Loader />
              <Typography state="grey" variant="body2">
                Loading data...
              </Typography>
            </div>
          ) : Number(totalTransVolume) > 0 ? (
            <div
              style={{
                position: "relative",
                height: "18rem",
              }}
            >
              <ResponsiveContainer width="100%" height="100%">
                <PieChart width={500} height={500}>
                  <Pie
                    data={data.details?.map((entry) => ({
                      value:
                        transactionType === "1"
                          ? Number(entry.volumePerc)
                          : Number(entry.valuePerc),
                    }))}
                    dataKey="value"
                    cx="50%"
                    cy="50%"
                    outerRadius={isSmallScreen ? 70 : 90}
                    // label={(val) => `${(val.percent * 100).toFixed(0)}%`}
                    fill="#82ca9d"
                    stroke=""
                  >
                    {data?.details?.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={colorCodes[index]} />
                    ))}
                  </Pie>
                </PieChart>
              </ResponsiveContainer>
            </div>
          ) : (
            <div style={{ height: "13rem" }}>
              <Typography
                state="grey"
                variant="body2"
                className={" text-center mtop-4 mbottom-4"}
              >
                No information within the selected dates
              </Typography>
            </div>
          )}
        </div>
        <div className="col-5 pt-1">
          <div className="d-flex justify-content-end">
            <Select
              required={false}
              className={"transaction-type-select"}
              name="dataType"
              value={transactionType}
              onChange={(e) => setTransactionType(e.target.value)}
              options={[
                { label: "Volume", value: "1" },
                { label: "Value", value: "2" },
              ]}
            />
          </div>
          {!loading && details?.length ? (
            <div className="mt-2 ">{getColorIndicators()}</div>
          ) : (
            ""
          )}
        </div>
      </div>
      <div className="w-100 text-center" style={{ marginTop: "-1rem" }}>
        {!loading && details?.length ? (
          <>
            <div className="d-flex justify-content-center align-items-center">
              <Typography variant="caption1" className={"mx-4"}>
                Total Transaction {transactionType === "1" ? "Volume" : "Value"}
              </Typography>{" "}
              <Typography state="primary" variant="body2">
                {transactionType === "1"
                  ? formatAmount(totalTransVolume)
                  : formatAmount(totalTransValue)}{" "}
              </Typography>{" "}
              &nbsp;
              <img src={transactionVolumeImg} height="13px" alt="" />{" "}
            </div>
            <div className="mt-2 mx-auto" style={{ width: "70%" }}>
              <div className="d-flex justify-content-center">
                {data.details?.map((info, key) => (
                  <div key={key} className="d-flex mx-2">
                    <div
                      className="transaction-indicator"
                      style={{
                        backgroundColor: colorCodes[key],
                        marginTop: ".2rem",
                      }}
                    ></div>
                    <Typography variant="caption0">
                      {transactionType === "1"
                        ? formatAmount(info.volume)
                        : formatAmount(info.value)}
                    </Typography>
                  </div>
                ))}
              </div>
            </div>
          </>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default TransactionTypeStats;
